// extracted by mini-css-extract-plugin
export default {"errorText":"src-components-ErrorModal-ErrorModal__errorText--RJHYy"};